import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Msq from "@MasterBluePrint/Components/Msq";
import { FormattedCommaSeparatedValue } from "@MasterBluePrint/Services/FormattedValueService";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";

import * as React from "react";
import { css } from "styled-components";

const enum fields {
    minQtyLabel = "minQtyLabel",
    mulQtyLabel = "mulQtyLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.minQtyLabel]: string;
        [fields.mulQtyLabel]: string;
    };
}
type Props = OwnProps & HasProduct;

export interface ProductDetailsMinMultiStyle {
    minMultiQtyContainer?: InjectableCss;
    minMultiWrapper?: InjectableCss;
    minQtyLabel?: InjectableCss;
    minQtyValue?: InjectableCss;
    maxQtyLabel?: InjectableCss;
    maxQtyValue?: InjectableCss;
}

export const minMulQtyStyles: ProductDetailsMinMultiStyle = {
    minMultiQtyContainer: {
        css: css`
        font-weight: 600;
        font-size: .9rem !important;
        font-family: 'Lato', sans-serif;
        font-style: italic;
        div {
            display: inline-block;
            margin-top: 1rem;
            position: relative;

        }
        `,
    },
    minMultiWrapper: {
        css: css`
            color: ${themeColors.colorCharcoalGrey};
        `,
    },
    minQtyLabel: {
        css: css`
        margin-right:.5rem;
        font-style: italic;
        margin-top: 1.7rem;
        font-size:.85rem;
        margin-bottom: 1.1rem;
    position: relative;
    display: inline-block;
    color: #333F48;
    font-family: 'Lato', sans-serif;
        `,
    },
    minQtyValue: {
        css: css`
        color: #333F48;
        font-family: 'Lato', sans-serif;
        font-weight:400;
        font-style: italic;
        `,
    },
    maxQtyLabel: {
        css: css`
        color: #333F48;
        font-family: 'Lato', sans-serif;
        font-weight:400;
        font-style: italic;
        `,
    },
    maxQtyValue: {
        css: css`
        color: #333F48;
        font-family: 'Lato', sans-serif;
        font-weight:400;
        font-style: italic;
        `,
    },
};

const styles = minMulQtyStyles;

const ProductDetailsMinMulti: React.FC<Props> = ({ fields, product }) => {
    if (!product) {
        return null;
    }


    if (product) {
        return (
            <StyledWrapper>
                {/* {product.minimumOrderQty > 0 ? (
                    <StyledWrapper>
                        <Typography {...styles.minQtyLabel}>
                            {fields.minQtyLabel || translate("Min Qty: ")}
                        </Typography>
                        <Typography {...styles.minQtyValue}>
                            {product.minimumOrderQty}
                        </Typography>
                    </StyledWrapper>
                ) : ''}
                {product.minimumOrderQty > 0 && product.detail?.multipleSaleQty !== 0 ? (
                    // <Typography>&#124;</Typography>
                    <Typography>|</Typography>

                ) : ''} */}

                {product.detail?.multipleSaleQty && product.detail?.multipleSaleQty > 1 ? (
                    <StyledWrapper {...styles.minMultiWrapper} className="min-multi-detail">
                        <Typography {...styles.minQtyLabel}>
                            {fields.mulQtyLabel || translate("Multiples of:")}
                        </Typography>
                        <Typography {...styles.minQtyValue}>
                            {FormattedCommaSeparatedValue(product.detail?.multipleSaleQty)}
                        </Typography>
                    </StyledWrapper>
                ) : (
                    ""
                )}
            </StyledWrapper>
        );
    }

    return <></>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsMinMulti),
    definition: {
        displayName: "Min-Multi Qty",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.minQtyLabel,
                editorTemplate: "TextField",
                defaultValue: "Min Qty: ",
                fieldType: "General",
            },
            {
                name: fields.mulQtyLabel,
                editorTemplate: "TextField",
                defaultValue: "Multiples of: ",
                fieldType: "General",
            },
        ]
    },
};
export default widgetModule;